<div class="navbar-area">
  <div class="mobile-nav">
    <a routerLink="/" class="logo"
      ><img
        src="assets/img/logo/ringpilot_logo.png"
        width="100%"
        height="auto"
        alt="Logo"
    /></a>
  </div>

  <div class="main-nav nav-bar-two">
    <div class="container-fluid">
      <nav class="container-max-2 navbar navbar-expand-md navbar-light">
        <a class="navbar-brand" routerLink="/"
          ><img src="assets/img/logo/ringpilot_logo.png" alt="Logo"
        /></a>

        <div
          class="collapse navbar-collapse mean-menu"
          id="navbarSupportedContent"
        >
        <ul class="navbar-nav m-auto">
          <ng-container *ngIf="navigationData">
            <ng-container *ngFor="let item of navigationData.mainMenu">
              <!-- Regular menu item -->
              <li
                class="nav-item"
                *ngIf="!item.hasDropdown"
              >
                <a
                  [routerLink]="item.link"
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  {{ item.title }}
                </a>
              </li>
        
              <!-- Dropdown menu item -->
              <li
                class="nav-item dropdown"
                *ngIf="item.hasDropdown"
                style="position: relative"
              >
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  [id]="'dropdown-' + item.id"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ item.title }}
                </a>
                <ul
                  class="dropdown-menu"
                  [attr.aria-labelledby]="'dropdown-' + item.id"
                >
                  <li *ngFor="let dropdownItem of item.dropdownItems">
                    <a
                      class="dropdown-item"
                      [routerLink]="dropdownItem.link"
                    >
                      {{ dropdownItem.title }}
                    </a>
                  </li>
                </ul>
              </li>
            </ng-container>
          </ng-container>
        </ul>
        

          <div class="side-nav d-flex align-items-center">
            <ul class="navbar-nav">
              <button class="btn btn-get-started me-2" routerLink="/sign-up">
                <i class="bi bi-fire"></i> Sign Up
              </button>
              <button class="btn btn-login" routerLink="/sign-in">
                <i class="bi bi-box-arrow-in-right"></i> Log In
              </button>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <div class="side-nav-responsive">
    <div class="container">
      <div class="dot-menu">
        <div class="circle-inner">
          <div class="circle circle-one"></div>
          <div class="circle circle-two"></div>
          <div class="circle circle-three"></div>
        </div>
      </div>

      <div class="container">
        <div class="side-nav-inner">
          <div class="side-nav justify-content-center align-items-center">
            <div class="side-item">
              <div class="search-box">
                <i class="flaticon-loupe"></i>
              </div>
            </div>
            <div class="side-item">
              <div class="user-btn">
                <a routerLink="/"><i class="flaticon-contact"></i></a>
              </div>
            </div>
            <div class="side-item">
              <div class="nav-add-btn">
                <a routerLink="/contact" class="nav-menu-btn"
                  >Contact Us <i class="bx bx-plus"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="search-overlay">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="search-layer"></div>
      <div class="search-layer"></div>
      <div class="search-layer"></div>

      <div class="search-close">
        <span class="search-close-line"></span>
        <span class="search-close-line"></span>
      </div>

      <div class="search-form">
        <form>
          <input
            type="text"
            class="input-search"
            placeholder="Search here..."
          />
          <button type="submit"><i class="flaticon-loupe"></i></button>
        </form>
      </div>
    </div>
  </div>
</div>
